import { render, staticRenderFns } from "./SparsCategories.vue?vue&type=template&id=0973604a&scoped=true"
import script from "./SparsCategories.vue?vue&type=script&lang=js"
export * from "./SparsCategories.vue?vue&type=script&lang=js"
import style0 from "./SparsCategories.vue?vue&type=style&index=0&id=0973604a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0973604a",
  null
  
)

export default component.exports